import VueTimepicker from "vue2-timepicker";
import VueTagsInput from "@johmun/vue-tags-input";

Vue.component('reporting', {
    components: {
        VueTimepicker, VueTagsInput
    },

    props: ['client-id'],

    data () {
        return {
            loading: false,

            modalLoading: false,

            schedule: [],

            history: [],

            viewing: 'schedule',

            deleteId: null,

            reportId: null,

            deleting: false,

            createScheduleForm: $.extend(true, new Form({
                data: {
                    client: this.clientId,
                    interval: '',
                    day_of_week: '',
                    day_of_month: '',
                    time: '',
                    recipient: '',
                    recipients: [
                        {
                            "text": "reports@thequadgroup.com",
                            "tiClasses": ["ti-valid"]
                        }
                    ]
                }
            }), {}),

            editScheduleForm: $.extend(true, new Form({
                data: {
                    client: this.clientId,
                    interval: '',
                    day_of_week: '',
                    day_of_month: '',
                    time: '',
                    recipient: '',
                    recipients: []
                }
            }), {}),

            runningReport: false
        };
    },

    mounted () {
        this.getSchedule();

        $('#edit-report').on('hidden.bs.modal', () => {
            this.editScheduleForm.resetForm();
            this.editScheduleForm.resetAlert();
            this.editScheduleForm.data.recipients = [];
        });
    },

    methods: {
        getSchedule () {
            this.loading = true;

            axios.get('/api/reports/list', {
                params: {
                    client: this.clientId
                }
            }).then(response => {
                this.loading = false;
                this.schedule = response.data;
            });
        },

        getHistory (page) {
            this.loading = true;

            axios.get('/api/reports/history', {
                params: {
                    client: this.clientId,
                    page: page
                }
            }).then(response => {
                this.loading = false;
                this.history = response.data;
            });
        },

        viewHistory () {
            this.viewing = 'history';

            if (this.history.length === 0) {
                this.getHistory();
            }
        },

        viewSchedule () {
            this.viewing = 'schedule';

            if (this.schedule.length === 0) {
                this.getSchedule();
            }
        },

        createSchedule () {
            Http.post('/api/reports/create', this.createScheduleForm).then((response) => {
                this.createScheduleForm.resetForm();

                $('#schedule-new').modal('hide');

                this.getSchedule();
            });
        },

        editReport (id) {
            $('#edit-report').modal('show');
            this.modalLoading = true;

            this.reportId = id;

            axios.get('/api/reports/edit/' + id).then(response => {
                this.modalLoading = false;

                this.editScheduleForm.data.interval = response.data.interval;
                this.editScheduleForm.data.time = response.data.time;

                if (['weekly', 'fortnightly'].indexOf(response.data.interval) !== -1) {
                    this.editScheduleForm.data.day_of_week = response.data.day;
                } else if (['monthly'].indexOf(response.data.interval) !== -1) {
                    this.editScheduleForm.data.day_of_month = response.data.day;
                }

                for (let recipient of response.data.recipients) {
                    this.editScheduleForm.data.recipients.push({
                        "text": recipient,
                        "tiClasses": ["ti-valid"]
                    });
                }
            });
        },

        updateReport() {
            Http.post('/api/reports/update/' + this.reportId, this.editScheduleForm).then((response) => {
                $('#edit-report').modal('hide');

                this.getSchedule();
            });
        },

        deleteSchedule (id) {
            $('#delete').modal('show');
            this.deleteId = id;
        },

        doDelete () {
            this.deleting = true;

            axios.post('/api/reports/delete/' + this.deleteId).then(response => {
                $('#delete').modal('hide');
                this.getSchedule();
                this.deleting = false;
            });
        },

        resend (id) {
            this.runningReport = true;

            axios.post('/api/reports/run/' + id).then(response => {
                this.runningReport = false;
            });
        }
    }
});